export default "__VITE_ASSET__nJlGTsVT__"